export default async (context) => {
    context.videos = []

    await context.entry.forEach(item => {
        context.videos.push(item)
    })

    await context.main.forEach(item => {
        context.videos.push(item)
    })

    await context.ending.forEach(item => {
        context.videos.push(item)
    })

    context.videos = await context.videos.map(item => ({
        id: item.type === 'text' ? null : item.id,
        control: item.control ? item.control : null,
        type: item.type,
        descr: item.descr ? item.descr : null,
        color: item.color ? item.color : null
    }))
}